<template>
  <div>
    <div class="rounded border border-gray-400 bg-white max-w-3xl text-sm">
      <dl>
        <div class="bg-gray-100 p-5 rounded-t lg:grid lg:grid-cols-4">
          <dt class="text-gray-600">Agency</dt>
          <dd class="col-span-3">
            {{ account.name }}
          </dd>
        </div>

        <div class="bg-white p-5 lg:grid lg:grid-cols-4">
          <dt class="text-gray-600">Code</dt>
          <dd class="col-span-3">
            {{ clientAgency.code }}
          </dd>
        </div>

        <div class="bg-gray-100 p-5 rounded-b lg:grid lg:grid-cols-4">
          <dt class="text-gray-600">Balance</dt>
          <dd class="col-span-3">{{ clientAgency.balance.toFixed(2) }} &euro;</dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapGetters('ui/clientAgencies', ['clientAgency']),
    ...mapState('entities', {
      account({ accounts }) {
        return accounts.byId[this.clientAgency.account_uuid];
      },
    }),
  },
};
</script>
